import React from "react";
import { Home, FileText, Wallet, User } from "lucide-react";

export default function BottomNav({ active, go, notify }) {
  const items = [
    { key: "home", label: "Ana səhifə", icon: Home, onClick: () => go("home") },
    {
      key: "applications",
      label: "Müraciətlər",
      icon: FileText,
      onClick: () => go("applications"),
    },
    {
      key: "payments",
      label: "Ödənişlər",
      icon: Wallet,
      onClick: () => notify("Ödənişlər bölməsi tezliklə aktiv olacaq"),
    },
    { key: "profile", label: "Profil", icon: User, onClick: () => go("profile") },
  ];
  return (
    <nav className="bottom-nav">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <button
            key={it.key}
            className={active === it.key ? "active" : ""}
            onClick={it.onClick}
          >
            <Icon size={22} strokeWidth={2} />
            {it.label}
          </button>
        );
      })}
    </nav>
  );
}
